import { StateCreatorWithDevtools } from '../store-utils';
import { Vector2 } from 'peet-math';
import { PlanSection } from 'mobile-venue-plan-js/lib/plan-section';
import { getTicketSelectionInfo, unselectSpecificTickets } from '../../mvcapi/buy-ticket-api';
import { VenuePlanSearchStoreSlice } from './venue-plan-search-store-slice';
import { AddTicketsToCartStore, useAddTicketsToCartStore } from '../add-tickets-to-cart-store';
import { distributePriceGroupInsidePackageItems, distributePriceGroupInsideTicketItems } from '../../mvcapi/ticket-price';
import { AddToCartItem, AddToCartItemType, AddToCartPackageItem, AddToCartTicketItem, getTicketIdsFromItems } from './models/add-to-cart-items';
import { AddToCartRequestBase, PriceQuantity } from '../../mvcapi/models/buyticket/ticketselection';
import { getExpiredTicketsInWarningReport } from '../../logic/buytickets';
import { PriceGroupsByEventDateId, Section } from '../../mvcapi/models/buyticket';
import { useAddPackageToCartStoreExt } from './add-package-to-cart-store-ext';
import { AutoFindTicketModel } from '../../logic/models';

import toastr from 'toastr';


// INFO: New sale

export type AddTicketsToCartStoreAllSlices = TicketSelectionSlice & AddTicketsToCartStore & VenuePlanSearchStoreSlice;

export interface TicketSelectionSlice {

    ticketCount: number;

    /** Temporarily selected tickets that we hold after a ticket search and before we decide the price we want on them. */
    // tempSelectedAddToCartItems: SelectedTicketInfo[];
    // setTempSelectedAddToCartItems: (tempSelectedAddToCartItems: SelectedTicketInfo[]) => void;

    /** Faire des temp AddToCartItem tempSelectedItems au lieu des tempSelectedAddToCartItems */
    tempSelectedAddToCartItems: AddToCartItem[];
    setTempSelectedAddToCartItems: (tempSelectedItems: AddToCartItem[]) => void;

    ticketSelectionInfoLoading: boolean;
    ticketPriceSelectionEditMode: boolean;
    showTicketPriceSelection: boolean;
    cancelPriceSelectionProcess: () => Promise<void>;
    confirmPriceSelection: (selectedTicketsWithPrice: AddToCartItem[], priceGroups: PriceQuantity[], priceGroupsByEventDateId: PriceGroupsByEventDateId) => void;

    showTicketPriceSelectionModal: (addToCartItems: AddToCartItem[], editMode: boolean) => void;
    addNewTicketConfirmCallback: { cb: (keepTickets: boolean) => void };
    closeTicketPriceSelectionModal: () => void;

    // Ticket search wizard =================================================
    selectedSection: Section;
    setSelectedSection: (sectionId: number) => void;

    autoFindTicket: AutoFindTicketModel;
    setAutoFindTicket: (autoFindTicket: AutoFindTicketModel) => void;

    showTicketSearchWizard: boolean;
    startTicketSearchWizard: () => void;

    /** Clears tempTicketState. If releaseInDb is true, also release tickets in database. */
    _clearTempSelectedTickets: (releaseInDb: boolean) => void;


    searchingTicket: boolean;
    setSearchingTicket: (searchingTicket: boolean) => void;

    searchTicketStep: "FIND_TICKET" | "PRICE_GROUP";
    setSearchTicketStep: (currentStep: "FIND_TICKET" | "PRICE_GROUP") => void;
    searchTicketErrorMessage: string;
    setSearchTicketErrorMessage: (errorMessage: string) => void;

    // Ticket removal process ===============================================
    ticketsAwaitingForRemoval: { /*eventDateId: number,*/ ticketIds: number[], unselectSpecificTickets: boolean };
    showRemoveTicketsConfirmPopup: boolean;

    startTicketRemovalProcessWithConfirm: (ticketIds: number[]) => void;
    cancelRemoveTicketsProcess: () => void;

    /** Sauvegarde la liste après avoir terminer d'ajouter les items avec leur association de prix */
    /** Permet à un store externe de s'y connecter pour les tâches après sélection de prix */
    handleItemsSelectedExternalLogic: { cb: (selectedItemsWithPrice: AddToCartItem[], isUpdate?: boolean) => void };

    /** Starts a ticket search process using a point on plan */
    startTicketSearchByPointOnPlan: (pointOnPlan: Vector2) => void;
    /** Starts a ticket search process using a section */
    startTicketSearchBySection: (section: PlanSection) => void;
    /** Closes an active ticket search process */
    _closeTicketSearchWizard: () => void;
    confirmItemSearchWizardDone: (associatedItemsWithPrices: AddToCartItem[]) => void;
    // confirmTicketSearchWizardDone: (associatedTicketsWithPrices: SelectedTicketInfo[]) => void;

    refreshTicketSelectionInfo: () => void;

    /** Used by the top sale component. Check if this is really need in the future. Could it be just a state? Or an event emitter. */
    onFindTicketsWhenNoPriceCallBack: (autoFindTicket: AutoFindTicketModel) => void;
    setOnFindTicketsWhenNoPriceCallback: (cb: (autoFindTicket: AutoFindTicketModel) => void) => void;
}

export const TicketSelectionSliceDef: StateCreatorWithDevtools<TicketSelectionSlice & AddTicketsToCartStoreAllSlices, TicketSelectionSlice> = (set, get) => {
    return {

        ticketCount: 0,

        // tempSelectedAddToCartItems: null,
        // setTempSelectedAddToCartItems: (tempSelectedAddToCartItems: SelectedTicketInfo[]) => set({ tempSelectedAddToCartItems }, false, "tempSelectedAddToCartItems"),

        tempSelectedAddToCartItems: null,
        setTempSelectedAddToCartItems: (tempSelectedAddToCartItems: AddToCartItem[]) => set({ tempSelectedAddToCartItems }, false, "tempSelectedItems"),

        /** This represents when some ticket info are loading/reloading like the warnings */
        ticketSelectionInfoLoading: false,

        ticketPriceSelectionEditMode: false,

        showTicketPriceSelection: false,

        searchingTicket: false,
        setSearchingTicket: (searchingTicket: boolean) => set({ searchingTicket }, false, "setsearchingTicket"),

        searchTicketStep: "FIND_TICKET",
        setSearchTicketStep: (searchTicketStep: "FIND_TICKET" | "PRICE_GROUP") => set({ searchTicketStep }, false, "searchTicketStep"),

        searchTicketErrorMessage: null,
        setSearchTicketErrorMessage: (errorMessage: string) => set({ searchTicketErrorMessage: errorMessage }, false, "searchTicketErrorMessage"),

        //foundTickets: false,
        //setOnFoundTickets: (foundTickets: boolean) => set({ foundTickets }, false, "setOnFoundTickets"),

        addNewTicketConfirmCallback: null,
        handleItemsSelectedExternalLogic: null,

        selectedSection: null,
        setSelectedSection: (sectionId: number) => {
            let section = get().eventDate?.Sections?.find(s => s.ID === sectionId);
            if(useAddPackageToCartStoreExt.getState().isAPackageSale())
                section = useAddPackageToCartStoreExt.getState().package?.Sections?.find(s => s.ID === sectionId); 

            if(section)
                set({ selectedSection: section }, false, "selectedSection");
        },

        autoFindTicket: null,
        setAutoFindTicket: (autoFindTicket: AutoFindTicketModel) => set({ autoFindTicket }, false, "setAutoFindTicket"),

        showTicketSearchWizard: false,

        ticketsAwaitingForRemoval: null,
        showRemoveTicketsConfirmPopup: false,
        
        // Ticket search process
        showTicketPriceSelectionModal: (addToCartItems: AddToCartItem[], editMode: boolean) => {
            let ticketCount = addToCartItems.length;

            set({
                tempSelectedAddToCartItems: addToCartItems,
                ticketPriceSelectionEditMode: editMode,
                ticketCount:ticketCount,
                showTicketPriceSelection: true,
            }, false, { type: "showTicketPriceSelection", addToCartItems, editMode });
        },

        closeTicketPriceSelectionModal: () => {
            set({
                showTicketPriceSelection: false,
                selectedSection: null,
                ticketCount: 0,
                addNewTicketConfirmCallback: null, 
                ticketPriceSelectionEditMode: false
            }, false, "closeTicketPriceSelectionModal");

            
        },

        cancelPriceSelectionProcess: async () => {

            if(get().addNewTicketConfirmCallback) {
                get().addNewTicketConfirmCallback.cb(false);
                set({ addNewTicketConfirmCallback: null }, false, "cancelPriceSelectionProcess/clear-callback-after-use/addNewTicketConfirmCallback");
            }
    
            get()._clearTempSelectedTickets(!get().ticketPriceSelectionEditMode); // Clear in DB if not in edit mode

            // In the case it was used during a wizard
            get()._closeTicketSearchWizard();
            get().closeTicketPriceSelectionModal();
        },

        confirmPriceSelection: (selectedAddToCartItems: AddToCartItem[], pricesQty: PriceQuantity[], priceGroupsByEventDateId: PriceGroupsByEventDateId) => {
            const isAPackageSale = selectedAddToCartItems[0].type == AddToCartItemType.Package;

            let selectedItemsWithPrice: AddToCartItem[] = [];
            if(isAPackageSale)
                selectedItemsWithPrice = distributePriceGroupInsidePackageItems(selectedAddToCartItems as AddToCartPackageItem[], pricesQty, priceGroupsByEventDateId);
            else
                selectedItemsWithPrice = distributePriceGroupInsideTicketItems(selectedAddToCartItems as AddToCartTicketItem[], pricesQty);

            if(get().showTicketSearchWizard) { // If we are in the ticket search wizard
                if(!get().ticketPriceSelectionEditMode && get().addNewTicketConfirmCallback) {
                    get().addNewTicketConfirmCallback.cb(true);
                    set({ addNewTicketConfirmCallback: null }, false, "confirmPriceSelection/clear-callback-after-use/addNewTicketConfirmCallback");
                }

                get().confirmItemSearchWizardDone(selectedItemsWithPrice /*, selectedTickets*/);
            } else { // Else, standalone modal usage
                if(get().handleItemsSelectedExternalLogic)
                    get().handleItemsSelectedExternalLogic.cb(selectedItemsWithPrice, get().ticketPriceSelectionEditMode);
                else
                    get().handleItemsSelected(selectedItemsWithPrice, get().ticketPriceSelectionEditMode);

                //get().handleItemsSelected(selectedItemsWithPrice, get().ticketPriceSelectionEditMode);
                if(!get().ticketPriceSelectionEditMode && get().addNewTicketConfirmCallback) {
                    get().addNewTicketConfirmCallback.cb(true);
                    set({ addNewTicketConfirmCallback: null }, false, "confirmPriceSelection/clear-callback-after-use/addNewTicketConfirmCallback");
                }

                get().closeTicketPriceSelectionModal();
            }
        },

        confirmItemSearchWizardDone: (associatedItemsWithPrices: AddToCartItem[]): void => {
            //const selectedTickets = get().searchWizardSelectedTickets;
            get()._closeTicketSearchWizard();
            get()._clearTempSelectedTickets(false);
            if(get().handleItemsSelectedExternalLogic)
                get().handleItemsSelectedExternalLogic.cb(associatedItemsWithPrices);
            else
                get().handleItemsSelected(associatedItemsWithPrices);

            //get().handleItemsSelected(associatedItemsWithPrices);
        },

        startTicketSearchByPointOnPlan: (pointOnPlan: Vector2) => {
            // Afficher le sélecteur de quantité de billets désirés
            get().setTicketSearchPoint(pointOnPlan);
            get().startTicketSearchWizard();
        },
    
        startTicketSearchBySection: (section: PlanSection) => {
            get().setSelectedSection(section.id);
            get().startTicketSearchWizard();
        },

        startTicketSearchWizard: () => {
            set({ 
                showTicketSearchWizard: true, 
                searchTicketStep: 'FIND_TICKET' 
            }, false, "startTicketSearchWizard");
        },

        _closeTicketSearchWizard: () => {
            set({
                showTicketSearchWizard: false,
                ticketSearchPoint: null,
                selectedSection: null,
                ticketCount: 0,
            }, false, "closeTicketSearchWizard");
        },

        _clearTempSelectedTickets: async (releaseInDb: boolean) => {
            if(get().tempSelectedAddToCartItems && get().tempSelectedAddToCartItems.length > 0) {
                const items = get().tempSelectedAddToCartItems;
                set({ tempSelectedAddToCartItems: null }, false, "clearTempSelectedTickets");
                if(releaseInDb) {
                    // TODO: voir ici comment on va gérer les forfaits 
                    await unselectSpecificTickets(getTicketIdsFromItems(items));
                }
            }
        },


        refreshTicketSelectionInfo: async () => {
            set({ticketSelectionInfoLoading: true}, false, "refreshTicketSelectionInfo/loading");
            try {
                const isAPackageSale = useAddPackageToCartStoreExt.getState().isAPackageSale();
                let packageId = null;
                let selectedEventDateIds = null;
                let addToCartRequest: AddToCartRequestBase = null;

                if(isAPackageSale) {
                    packageId = useAddPackageToCartStoreExt.getState().packageId;
                    selectedEventDateIds = useAddPackageToCartStoreExt.getState().selectedEventDateIds;
                    addToCartRequest = useAddPackageToCartStoreExt.getState().getAddToCartRequest();
                } 
                else {
                    selectedEventDateIds = [useAddTicketsToCartStore.getState().eventDateId];
                    addToCartRequest = get().getAddToCartRequest();
                }

                const info = await getTicketSelectionInfo(addToCartRequest, selectedEventDateIds, packageId);

                useAddTicketsToCartStore.getState().setSelectionWarningReport(info.ticketSelectionWarningReport);
                useAddTicketsToCartStore.getState().setMembershipTypeSavingAmounts(info.membershipTypeSavingAmounts);
    
                let expiredTicketsWarning = getExpiredTicketsInWarningReport(info.ticketSelectionWarningReport, isAPackageSale);
                if(expiredTicketsWarning.expiredTicketIds.length > 0) {
                    if(isAPackageSale) {
                        await useAddPackageToCartStoreExt.getState().removeTickets(expiredTicketsWarning.expiredTicketIds, false);
                    }else
                        await get().removeTickets(expiredTicketsWarning.expiredTicketIds, false);
                    
                    toastr.error(expiredTicketsWarning.warningMessage);
                }
    
            }
            catch(err) {
                console.error(err);
            }
            set({ticketSelectionInfoLoading: false}, false, "refreshTicketSelectionInfo/loadingDone");
        },

        // Ticket remove process
        startTicketRemovalProcessWithConfirm: (ticketIds: number[]) => {
            if(!ticketIds || ticketIds.length === 0) return;
            set({ 
                ticketsAwaitingForRemoval: { ticketIds, unselectSpecificTickets: true },
                showRemoveTicketsConfirmPopup: true,
            });
        },

        cancelRemoveTicketsProcess: () => {
            set({ ticketsAwaitingForRemoval: null, showRemoveTicketsConfirmPopup: false });
        },

        onFindTicketsWhenNoPriceCallBack: null,
        setOnFindTicketsWhenNoPriceCallback: (cb: (autoFindTicket: AutoFindTicketModel) => void) => set({ onFindTicketsWhenNoPriceCallBack: cb }, false, "onFindTicketsWhenNoPriceCallBack"),
    };
};

